module.exports = __webpack_public_path__ + "img/chevron_black_right.24486938.png";